import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Box from "@mui/material/Box";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { onAuthStateChanged, signInWithCustomToken } from "@firebase/auth";
import { auth } from "./config/firebase";
import LoadingSpinner from "./components/layout/LoadingSpinner";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { Provider } from "react-redux";
import router from "./router/routes";
import { RouterProvider } from "react-router-dom";
import SafeAreaTop from "./components/layout/SafeAreaTop";
import { store } from "./config/store";
import theme from "./config/theme";
import { useEffect, useState } from "react";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      // Check for auto-sign-in token from website (sign-up or payment callback).
      // Must run even when already signed in — after paying, the custom token
      // carries updated claims (e.g. subscriptionStatus: active) that replace
      // the stale session.
      const params = new URLSearchParams(window.location.search);
      const token = params.get("token");
      if (token) {
        // Clean up the URL immediately so refresh doesn't retry
        window.history.replaceState({}, "", window.location.pathname);
        try {
          await signInWithCustomToken(auth, token);
          // For brand-new users (user was null), onAuthStateChanged will
          // fire again with the signed-in user — let that callback handle
          // setIsLoading(false) so the app renders with a valid auth state.
          // For already-authenticated users returning from payment, Firebase
          // may NOT re-fire (same UID), so we must fall through below.
          if (!user) return;
        } catch (error) {
          console.error("Auto sign-in failed:", error);
        }
      }
      setIsLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (isLoading) {
    return (
      <SafeAreaTop>
        <Box sx={{ width: "100%", height: "100%" }}>
          <LoadingSpinner />
        </Box>
      </SafeAreaTop>
    );
  }

  return (
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ThemeProvider theme={theme}>
          <CssBaseline>
            <RouterProvider router={router} />
          </CssBaseline>
        </ThemeProvider>
      </LocalizationProvider>
    </Provider>
  );
}

export default App;
